import { render } from "./OurProductsList.vue?vue&type=template&id=2b49d1a3&scoped=true"
import script from "./OurProductsList.vue?vue&type=script&lang=js"
export * from "./OurProductsList.vue?vue&type=script&lang=js"

import "./OurProductsList.vue?vue&type=style&index=0&id=2b49d1a3&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b49d1a3"]])

export default __exports__